<template>
  <div>
    <CoverBg
      show-text
      title="Blog"
      text="Lorem Ipsum Dolor Sit Amet, Consectetur Adipisicing Elit."
    />
    <Loading v-if="loading" />
    <b-container
      v-else
      class="main-container content-padding-t-b-100"
    >
      <div v-if="currentBlog">
        <div class="blog-item m-b-90">
          <BlogItemHeader
            :blog="currentBlog"
          />
          <div
            class="blog-description"
          >
            <p>
              {{ currentBlog && currentBlog.text || '' }}
            </p>
          </div>
        </div>
        <RelatedPost
          :id="currentBlogId"
          @get-data="getData"
        />
      </div>
      <h3
        v-else
        class="font-weight-bold text-center main-blue"
      >
        Page not found
      </h3>
    </b-container>
    <CoverBg
      bg="cover-bg-page-bottom"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { R_BLOG_DETAILS } from '@/router/routes';
import CoverBg from '@/components/CoverBg';
import BlogItemHeader from '@/components/Blog/BlogItemHeader';
import RelatedPost from '@/components/Blog/RelatedPost';
import Loading from '@/components/Loading';

export default {
  name: 'BlogDetails',
  components: {
    Loading,
    RelatedPost,
    BlogItemHeader,
    CoverBg,
  },
  props: {
    showShortDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      R_BLOG_DETAILS,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      currentBlog: (state) => state.blog.currentBlog,
    }),
    currentBlogId() {
      return this.currentBlog?.id;
    },
    blogId() {
      return this.$route.query?.id;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions([
      'getBlogById',
    ]),
    async getData() {
      this.loading = true;
      await this.getBlogById({
        id: this.blogId,
        notificationParams: {
          ctx: this,
        },
      }).then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>
